import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import moment from 'moment'
import $ from 'jquery'
// 省市区级联
import VDistpicker from 'v-distpicker'
// 图片验证码
import SIdentify from './components/identify'
// 引入echarts
import echarts from 'echarts'
//引入fecha
// import fecha from 'fecha'
// 引入v-viewer(图片浏览组件)
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
// 引入golbal文件，统一管理url
import global_ from './api/global.js'
// import jwt_decode from 'jwt-decode'
import elDragDialog from './assets/js/dialog';
Vue.use(elDragDialog);
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import './api/dialog'

Vue.use(Antd)
Vue.prototype.GLOBAL = global_;
// Vue.use(jwt_decode)
Vue.prototype.$echarts = echarts;
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.component("SIdentify",SIdentify);
Vue.use(Viewer,{
    defaultOptions:{
        zIndex:9999
    }
});

//给页面设置title做的配置
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    };
    next();
});
if(module.hot){
    module.hot.accept();
}

new Vue({
    el: '#app',
    router,
    render: h => h(App)
})
